import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { Route } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";
import request from "../../../Helpers/API";
import { GetKey, GetText } from "../../../Helpers/GetKey";

import { DashClienteContent } from "./DashClienteContent";
import { DashClienteExpediente } from "./CapturasDashClientes/DashClienteExpediente";
import DashClientesFacturacion from "./CapturasDashClientes/DashClientesFacturacion";

import { CtlInfoCliente } from "./CtlInfoCliente";
import Swal from "sweetalert2";

import DashCrearSolicitudCredito from "./CapturasDashClientes/DashCrearSolicitudCredito";
import DashBusquedaCliente from "./CapturasDashClientes/DashBusquedaCliente";
import { DashBusquedaClienteRFCScreen } from "./CapturasDashClientes/DashBusquedaClienteRFCScreen";
import { SolicitudCreditoListadoScreen } from "./CapturasDashClientes/SolitudDeCredito/SolicitudCreditoListadoScreen";
import { DashGenerarSolicitudCredito } from "./CapturasDashClientes/DashGenerarSolicitudCredito";
import { DashPedidoMaquinariascreen } from "./CapturasDashClientes/PedidoMaquinaria/DashPedidoMaquinariascreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { CtlInventarioMaquinariaDetalle } from "./CtlInventarioMaquinariaDetalle";
import { SCDocumentacion } from "./CapturasDashClientes/DocumentadionSC/SCDocumentacion";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const MyContext = React.createContext(null);

export const DashClienteMainScreen = () => {
  const location = useLocation();
  const history = useHistory();
  const [clienteslist, setClientesList] = useState([]);
  const [show, setShow] = useState(true);
  const [retornar, setRetornar] = useState(false);
  const [state, setState] = useState({
    clienteselect: "",
    clientesearch: "",
    titulosolicitud: "SELECCIONAR CLIENTE",
    folio: 0,
    idcliente: 0,
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [dashboard, setDashboard] = useState({
    info: {},
    documentos: [],
    lineas: [],
    totalcredito: {},
    equipofacturado: [],
    cultivos: [],
  });
  const onMostrarCliente = () => {
    if (show === true) {
      if (
        state.clientesearch === undefined ||
        state.clientesearch === null ||
        state.clientesearch === ""
      )
        return;
      setShow(false);
      setState({
        ...state,
        clienteselect: state.clientesearch,
        idcliente: Number(GetKey(state.clientesearch)),
      });
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `DashClientes/Dashboard?idcliente=${Number(
            GetKey(state.clientesearch)
          )}`
        )
        .then((result) => {
          setDashboard({
            documentos: result.documentos,
            lineas: result.linea,
            totalcredito: result.totalcredito,
            referenciabancaria: result.referenciabancaria,
            equipofacturado: result.equipofacturado,
            info: result.info,
            cultivos: result.cultivos,
          });
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("COBRANZA", JSON.stringify(error), "error");
        });
    } else {
      setShow(true);
      setState({
        ...state,
        clientesearch: "",
      });
      setDashboard({
        info: {},
        documentos: [],
        lineas: [],
        totalcredito: {},
        inventario: [],
      });
    }
  };
  const onMostrarCliente_Facturado = (idcliente_location, cliente_location) => {
    setShow(false);
    setRetornar(true);
    setState({
      ...state,
      clienteselect: idcliente_location + "-" + cliente_location,
      idcliente: Number(idcliente_location),
    });
    setLoader({ ...loader, mostrar: true });
    request
      .get(`DashClientes/Dashboard?idcliente=${Number(idcliente_location)}`)
      .then((result) => {
        setDashboard({
          documentos: result.documentos,
          lineas: result.linea,
          totalcredito: result.totalcredito,
          referenciabancaria: result.referenciabancaria,
          equipofacturado: result.equipofacturado,
          info: result.info,
          cultivos: result.cultivos,
        });
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("COBRANZA", JSON.stringify(error), "error");
      });
  };
  useEffect(() => {
    if (location.state !== undefined && location.state !== null) {
      onMostrarCliente_Facturado(
        location.state.idcliente,
        location.state.cliente
      );

      return;
    }
    request
      .get("Clientes/DropDownList")
      .then((result) => {
        setClientesList(result);
      })
      .catch((error) => {
        JSON.stringify("CLIENTES", "ERROR....", "error");
      });
  }, []);
  useEffect(() => {
    if (
      state.clientesearch !== undefined &&
      state.clientesearch !== null &&
      state.clientesearch !== ""
    ) {
      onMostrarCliente();
    }
  }, [state.clientesearch]);
  return (
    <MyContext.Provider value={{ state, setState }}>
      <LoaderScreen loader={loader} />
      <div id="dash-clientes-theme">
        <header
          id="dash-clientes-theme-header"
          className="dash-clientes-header"
        >
          <div className="dash-clientes-search">
            {show === true && (
              <Autocomplete
                size="small"
                id="dash-razonsocial"
                freeSolo
                className="dash-cliente-search-razonsocial"
                value={state.clientesearch}
                onChange={({ target }) =>
                  setState({ ...state, clientesearch: target.outerText })
                }
                options={clienteslist.map(
                  (option) => `${option.id} - ${option.display}`
                )}
                renderInput={(params) => (
                  <TextField {...params} label="SELECCIONAR CLIENTE" />
                )}
                sx={{
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& fieldset": { border: "none" },
                }}
              />
            )}

            {show === false && (
              <>
                <div className="dash-clientes-razonsocial2">
                  {GetText(state.clienteselect)}
                </div>
                {retornar === true ? (
                  <button
                    className="dash-clientes-search-button2"
                    onClick={() =>
                      history.push(
                        "/Ventas/SolicitudesCreditoFacturadas",
                        {
                          ejercicio: location.state.ejercicio,
                          periodo: location.state.periodo,
                        }
                      )
                    }
                  >
                    <ArrowBackIcon />
                  </button>
                ) : (
                  <button
                    className="dash-clientes-search-button2"
                    onClick={() => onMostrarCliente()}
                  >
                    X
                  </button>
                )}
              </>
            )}
          </div>
        </header>
        <div
          id="dash-clientes-theme-informacion"
          className="dash-clientes-theme-header"
        >
          <CtlInfoCliente data={dashboard.info} />
        </div>
        <Route
          path="/DashClientes/Main"
          component={() => <DashClienteContent dashboard={dashboard} />}
        />
        <Route
          path="/DashClientes/facturaciondetalle"
          component={() => (
            <DashClientesFacturacion
              idcliente={Number(GetKey(state.clienteselect))}
            />
          )}
        />
        <Route
          path="/DashClientes/expedientedigital"
          component={() => (
            <DashClienteExpediente
              idcliente={Number(GetKey(state.clienteselect))}
            />
          )}
        />
        <Route
          path="/DashClientes/inventariomaquinariadetalle"
          component={() => <CtlInventarioMaquinariaDetalle />}
        />
        <div
          className="dash-cientes-solicitud-credito-theme"
          id="dash-cientes-solicitud-credito-theme"
        >
          <header className="dash-cientes-solicitud-credito-theme-header">
            <div className="dash-cientes-solicitud-credito-theme-header-titulo">
              {state.titulosolicitud}
            </div>
            <div className="dash-cientes-solicitud-credito-theme-header-container-effect">
              <div className="dash-cientes-solicitud-credito-theme-header-container-effect-bl"></div>
              <div className="dash-cientes-solicitud-credito-theme-header-container-effect-circle"></div>
              <div className="dash-cientes-solicitud-credito-theme-header-container-effect-br"></div>
            </div>
          </header>
          <Route
            path="/DashClientes/busquedacliente"
            component={DashBusquedaCliente}
          />
          <Route
            path="/DashClientes/busquedaclienterfc"
            component={DashBusquedaClienteRFCScreen}
          />
          <Route
            path="/DashClientes/solicitudcreditolistado"
            component={SolicitudCreditoListadoScreen}
          />
          <Route
            path="/DashClientes/solicitudcreditoGenerar"
            component={DashGenerarSolicitudCredito}
          />
          <Route
            path="/DashClientes/solicitudcredito/crear"
            component={() => (
              <DashCrearSolicitudCredito
                idcliente={state.idcliente}
                folio={state.folio}
              />
            )}
          />
          <Route
            path="/DashClientes/solicitudcredito/pedidos"
            component={DashPedidoMaquinariascreen}
          />
          <Route
            path="/DashClientes/solicitudcredito/documentacion"
            component={SCDocumentacion}
          />
        </div>
      </div>
    </MyContext.Provider>
  );
};
